<template>
  <div>
    <slot :states="states" :year1="year1" :year2="year2"/>

    <div class="grid sm:grid-cols-2 md:grid-cols-3 gap-4 mt-5">
      <div v-for="state in sparklines" :key="state.code" class="border rounded">
        <div class="bg-gray-100 dark:bg-gray-800 px-3 border-b flex gap-2 items-center justify-between">
          <span class="py-2">
            {{ state.name }}
          </span>

          <div class="flex flex-col items-end leading-tight">
            <span :class="['font-semibold',state.change_percent < 0 ? 'text-red-600' : 'text-green-700']">
              {{ state.change_percent > 0 ? '+' : '' }}{{ state.change_percent }}%
            </span> <span class="text-gray-500 text-xs">from {{ year1 }} to {{ year2 }}</span>
          </div>
        </div>
        <simple-sparkline
          :id="`${state.code}_enrollment`"
          :data="state.data"
          x-key="enr"
          y-key="admission_year"
          y-label="Total 1Ls in "
          class="flex p-3 gap-3"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import SimpleSparkline from "@/components/sparklines/SimpleSparkline.vue"
import { computed } from "vue"

const props = defineProps({
  states: Object,
  year1: Number,
  year2: Number,
})

const sparklines = computed(() => {
  return props.states
})
</script>
